/**
 *  @class
 *  @function PlusProductRecommendations
 */
class PlusProductRecommendations extends HTMLElement {
  
	constructor() {
		super();

	}
	fetchProducts() {
		fetch(this.dataset.url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('plus-product-recommendations');

				if (recommendations && recommendations.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;
				}

				this.classList.add('product-recommendations--loaded');

        /* Dispatch custom event to signal that the products have been rendered */
				const plus_event = new CustomEvent('plus-product-recommendations-loaded', {
					bubbles: true,
				});
				this.dispatchEvent(plus_event);

			})
			.catch(e => {
				console.error(e);
			});
	}
	connectedCallback() {
		this.fetchProducts();
	}
}

customElements.define('plus-product-recommendations', PlusProductRecommendations);